module.exports = __webpack_public_path__ + "img/ditan_yj_zhuweiqing.1eac174f.jpg";